/**
 * Labstep
 *
 * @module components/Group/Action/Share
 * @desc Share a group
 */

import { EntityActionShare } from 'labstep-web/components/Entity/Action/Share';
import { ICONS } from 'labstep-web/constants/icons';
import type React from 'react';
import type { GroupActionShareProps } from './types';

export const GroupActionShare: React.FC<GroupActionShareProps> = ({
  group,
  actionComponentProps,
}) => {
  return group.canInvite ? (
    <EntityActionShare
      entity={group}
      actionComponentProps={{
        type: 'option',
        text: `Invite`,
        icon: ICONS.group.actions.share,
        ...actionComponentProps,
      }}
    />
  ) : null;
};
